export default (ex = {}, context = {}, languageContent = {}) => {
  // need proper logging
  console.error(ex);

  let error = { error: { message: ex.message }, status: 'rejected' };

  let genericMessage = {
    severity: 'ERROR',
    title: languageContent?.errorTitle || 'Error',
    instructions: languageContent?.genericError || 'An error has occurred. Please try again or contact support',
    buttons: [{ title: 'Ok', action: 'DISMISS' }]
  };

  let enhancedMessage = {};

  if (ex.stack) {
    error.error = ex.stack;
  } else {
    error.error = ex;
  }

  if (ex.isAxiosError && ex.message === 'Network Error') {
    enhancedMessage.instructions = languageContent?.networkError || 'Check your internet connection';
  }

  if (ex.isAxiosError && ex.response && ex.response.status) {
    let resource = context.resource || 'resource';
    switch (ex.response.status) {
      case 404:
        enhancedMessage.instructions = languageContent?.notFound?.replace('{{resource}}', languageContent[resource] || resource) || `Could not find the ${resource} you requested`;
        break;
      case 403:
        enhancedMessage.instructions = languageContent?.forbidden?.replace('{{resource}}', languageContent[resource] || resource) || `Access unavailable for the ${resource} action you requested`;
        break;
      case 401:
        enhancedMessage.instructions =
          (ex.response.data && ex.response.data.message) ||
          languageContent?.unauthorized ||
          'Your session has expired. Please log in again';
        enhancedMessage.buttons = [
          { title: languageContent?.returnToLogin || 'Return to Login', action: 'LOGOUT' }
        ];
        enhancedMessage.hasPasswordExpired = ex.response.data?.code === 1015;
        break;
      case 400:
        enhancedMessage.instructions =
          (ex.response.data && ex.response.data.message) ||
          languageContent?.invalidCredentials ||
          'Invalid credentials';
        break;
      default:
    }
  }

  let userMessage = Object.assign(
    {},
    genericMessage,
    context.userMessage,
    enhancedMessage
  );

  return { error, userMessage };
};
